/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "mUnityAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "burnOnMUnity",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "mUnityAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "mintOnMUnity",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "setTotalAssets",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "totalAssets",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x6080604052348015600f57600080fd5b506102998061001f6000396000f3fe608060405234801561001057600080fd5b506004361061004c5760003560e01c806301e1d114146100515780631765b3131461006657806318abc0901461007b5780635f846b821461008e575b600080fd5b60005460405190815260200160405180910390f35b6100796100743660046101af565b600055565b005b6100796100893660046101e4565b6100a1565b61007961009c3660046101e4565b610132565b60405163079cc67960e41b81526001600160a01b038381166004830152602482018390528416906379cc679090604401600060405180830381600087803b1580156100eb57600080fd5b505af11580156100ff573d6000803e3d6000fd5b505050508060005410610128578060008082825461011d9190610237565b9091555061012d9050565b600080555b505050565b806000808282546101439190610250565b90915550506040516340c10f1960e01b81526001600160a01b038381166004830152602482018390528416906340c10f1990604401600060405180830381600087803b15801561019257600080fd5b505af11580156101a6573d6000803e3d6000fd5b50505050505050565b6000602082840312156101c157600080fd5b5035919050565b80356001600160a01b03811681146101df57600080fd5b919050565b6000806000606084860312156101f957600080fd5b610202846101c8565b9250610210602085016101c8565b929592945050506040919091013590565b634e487b7160e01b600052601160045260246000fd5b8181038181111561024a5761024a610221565b92915050565b8082018082111561024a5761024a61022156fea26469706673582212206507ca76a1874ce1e7053ae5a6cdf74a70f7f2d0996f7a535844de8b2ea8f64364736f6c634300081d0033";
const isSuperArgs = (xs) => xs.length > 1;
export class MockTrinityPool__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
MockTrinityPool__factory.bytecode = _bytecode;
MockTrinityPool__factory.abi = _abi;
//# sourceMappingURL=MockTrinityPool__factory.js.map